'use client'

import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

interface ConsultationPrepModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const ConsultationPrepModal = ({ forceOpened = false, onClose }: ConsultationPrepModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const router = useRouter();
  const searchParams = useSearchParams();

  // Open the modal if forceOpened is true OR if url param matches
  useEffect(() => {
    if (forceOpened || searchParams?.get('modal') === 'consultation-prep') {
      open();
    }
  }, [forceOpened, open, searchParams]);

  const items = [
    { label: '상담 전 준비사항', path: '/blogs/1749198411597' },
    { label: '상담 시 주요 질문', path: '/blogs/1749198912919' },
    { label: '의사와의 소통 방법', path: '/consultation-prep/communication' },
    { label: '결정 전 고려사항', path: '/consultation-prep/considerations' }
  ];

  const handleItemClick = (path: string) => {
    router.push(path);
    close();
    if (onClose) onClose();
  };

  const handleClose = () => {
      close();
      if (onClose) onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      withCloseButton={false}
      centered
      radius={'lg'}
      padding={24}
      size="lg"
      closeOnClickOutside={true}
      classNames={{ 
        content: 'scrollbar-hide max-w-full md:max-w-[700px]', 
        overlay: 'cursor-pointer' 
      }}
    >
      <div className="flex flex-col gap-3 mb-5">
        <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
          수술 준비
        </div>
      </div>
      
      {/* Button Grid - Applying NoseModal styles */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 max-w-[560px] mx-auto">
        {items.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 text-center h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800`}
            onClick={() => handleItemClick(item.path)}
          >
            <div className="text-[15px] font-normal">
              {item.label}
            </div>
          </div>
        ))}
      </div>
      
      {/* Close Button */}
      <div className="flex gap-1 justify-end mt-5">
        <Button 
          classNames={themeVariables.button.gray} 
          onClick={handleClose}
        >
          닫기
        </Button>
      </div>
    </Modal>
  );
} 